"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProxyConnectionRpcRemote = void 0;
const dht_1 = require("@streamr/dht");
const utils_1 = require("@streamr/utils");
const logger = new utils_1.Logger(module);
class ProxyConnectionRpcRemote extends dht_1.RpcRemote {
    async requestConnection(direction, userId) {
        const request = {
            direction,
            userId: (0, utils_1.toUserIdRaw)(userId)
        };
        const options = this.formDhtRpcOptions({
            timeout: dht_1.EXISTING_CONNECTION_TIMEOUT
        });
        try {
            const res = await this.getClient().requestConnection(request, options);
            return res.accepted;
        }
        catch (err) {
            logger.debug(`ProxyConnectionRequest failed with error`, { err });
            return false;
        }
    }
}
exports.ProxyConnectionRpcRemote = ProxyConnectionRpcRemote;
//# sourceMappingURL=ProxyConnectionRpcRemote.js.map